import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { safeRender } from '../utils/safeRender';

const Wrap = styled.main`
  padding: 40px 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
`;

const Card = styled(Link)`
  border: 1px solid var(--bdr);
  border-radius: 16px;
  background: var(--card);
  box-shadow: var(--shadow);
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);
  }
`;

const CardImage = styled.div`
  width: 100%;
  height: 200px;
  background: #f5f5f5;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
`;

const CardContent = styled.div`
  padding: 20px;
  
  h3 {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 700;
  }
  
  .region {
    font-size: 14px;
    color: var(--muted);
    margin-bottom: 12px;
  }
  
  .description {
    font-size: 14px;
    line-height: 1.4;
    color: var(--fg);
  }
`;

const testDistricts = [
  {
    id: 1,
    slug: 'central',
    name: 'Центральный',
    region: 'Москва',
    image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&h=300&fit=crop',
    description: 'Престижный центральный район с развитой инфраструктурой и близостью к основным достопримечательностям города.'
  },
  {
    id: 2,
    slug: 'arbat',
    name: 'Арбат',
    region: 'Москва',
    image: 'https://images.unsplash.com/photo-1520637836862-4d197d17c93a?w=400&h=300&fit=crop',
    description: 'Исторический район с уникальной атмосферой, пешеходными зонами и культурными достопримечательностями.'
  },
  {
    id: 3,
    slug: 'zamoskvorechye',
    name: 'Замоскворечье',
    region: 'Москва',
    image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=400&h=300&fit=crop',
    description: 'Тихий район с парками и зелеными зонами, идеальный для семейной жизни.'
  },
  {
    id: 4,
    slug: 'dubai-marina',
    name: 'Дубай Марина',
    region: 'ОАЭ',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=400&h=300&fit=crop',
    description: 'Престижный морской район с небоскребами, яхт-клубами и роскошными апартаментами.'
  },
  {
    id: 5,
    slug: 'downtown',
    name: 'Даунтаун',
    region: 'ОАЭ',
    image: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?w=400&h=300&fit=crop',
    description: 'Деловой центр Дубая с Burj Khalifa, Dubai Mall и фонтанами.'
  }
];

export default function TestDistricts() {
  return (
    <Wrap className="container">
      <h1>Тестовые районы</h1>
      <p>Выберите район для просмотра обновленной карточки с новыми компонентами:</p>
      
      <Grid>
        {testDistricts.map(district => (
          <Card key={district.id} to={`/districts/${district.slug}`}>
            <CardImage src={district.image} />
            <CardContent>
              <h3>{district.name}</h3>
              <div className="region">{safeRender(district.region?.name || district.region?.name_ru || district.region?.name_en || district.region, '')}</div>
              <div className="description">{district.description}</div>
            </CardContent>
          </Card>
        ))}
      </Grid>
      
      <div style={{ marginTop: '40px', padding: '20px', background: 'var(--card)', borderRadius: '16px', border: '1px solid var(--bdr)' }}>
        <h3>Что нового в карточках районов:</h3>
        <ul>
          <li><strong>Слайдер района</strong> - красивый слайдер с изображениями и описанием</li>
          <li><strong>Краткое описание и менеджеры</strong> - информация о районе и эксперты в столбик</li>
          <li><strong>Кнопка "Подробнее"</strong> - ссылка на полное описание внизу страницы</li>
          <li><strong>5 секций недвижимости</strong> - новостройки, вторичка, коммерческая, аренда, коммерческая аренда</li>
          <li><strong>Каждая секция</strong> - 2 в ряд, 2 ряда, пагинатор</li>
          <li><strong>Подробное описание</strong> - с раскрывающимися списками по категориям</li>
        </ul>
      </div>
    </Wrap>
  );
}